import { render, staticRenderFns } from "./FileVaultView.vue?vue&type=template&id=8b282e14&scoped=true&"
import script from "./FileVaultView.vue?vue&type=script&lang=js&"
export * from "./FileVaultView.vue?vue&type=script&lang=js&"
import style0 from "./FileVaultView.vue?vue&type=style&index=0&id=8b282e14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b282e14",
  null
  
)

export default component.exports